<template>
    <div>
        <div class="box-title">{{ data.title }}</div>

        <div class="image-box" :class="className">

            <template v-if="data.data && data.data.length > 0">
                <a v-for="(item, index) in data.data" :key="index" :href="item.link"
                    style=" background: white;">
                    <div v-if="item.name == '文本'" class="box-content">
                        {{ item.url }}
                    </div>
                    <img v-else :src="decodeURIComponent(item.url)">

                </a>
            </template>
            <template v-else>
                <div class="image-null"><span class="el-icon-picture"></span></div>
            </template>


        </div>
    </div>
</template>

<script>
export default {
    name: 'Images',
    props: ['data', 'className'],
    computed: {
        updatedData() {
            return JSON.parse(JSON.stringify(this.data));
        }
    },
    watch: {
        updatedData() {
            this.$forceUpdate();
        }
    }
    // watch: {
    //     'data'(newValue, oldValue) {
    //         this.$forceUpdate()
    //         console.log('Property changed from', oldValue, 'to', newValue);
    //     }
    // },
}
</script>

<style lang="scss" scoped>
.box-content {
    height: 100%;
    // width: 100%;
    font-size: 18px;
    font-weight: 100;
    padding: 10px;
    background-color: #e4e4e4;
}

.box-title {
    padding: 10px;
    font-size: 22px;
}

.image-box {
    font-size: 0;

    img {
        width: 100%;
        max-width: 100%;
    }

    .image-null {
        background: #ffffff;
        height: 300px;
        font-size: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #c1c1c1;
        width: 100%;
    }

    a {
        display: block;
    }

    &.two {
        display: flex;
        flex-wrap: wrap;
        box-sizing: content-box;
        height: 100%;
        a {
            width: 50%;
            box-sizing: border-box;
            position: relative;
            overflow: hidden;
            display: block;
             padding-bottom: 50%;
            background: #e4e4e4;
            img {
                position: absolute;
                padding: none; 
            }
        }
    }

    &.three {
        height: 100px;
        overflow-y: auto;
        white-space: nowrap;
        box-sizing: content-box;
        height: 100%;
        a {
            width: 100px;
            height: 100px;
            margin: 0 4px;
            display: inline-block;
            vertical-align: bottom;
            background: #e4e4e4;
         }
    }
}
</style>